/* iYos — galería y selector de variantes de la ficha de producto. */

(function () {
  'use strict';

  function init(root) {
    gallery(root);
    variants(root);
  }

  /* ── Galería ───────────────────────────────────────────────────────── */
  function gallery(root) {
    var slides = root.querySelectorAll('[data-iyos-slide]');
    if (slides.length < 2) return;

    var thumbs = root.querySelectorAll('[data-iyos-thumb]');
    var indexEl = root.querySelector('[data-iyos-index]');
    var stage = root.querySelector('.iyos-gallery__stage');
    var current = 0;

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.hidden = k !== current; });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === current)); });
      if (indexEl) indexEl.textContent = current + 1;
    }

    root.querySelector('[data-iyos-prev]')?.addEventListener('click', function () { show(current - 1); });
    root.querySelector('[data-iyos-next]')?.addEventListener('click', function () { show(current + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(Number(t.dataset.iyosThumb)); });
    });

    // Flechas del teclado cuando el foco está dentro de la galería.
    root.querySelector('.iyos-gallery')?.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(current - 1); }
      if (e.key === 'ArrowRight') { show(current + 1); }
    });

    // Deslizar en táctil.
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.changedTouches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) show(current + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
  }

  /* ── Variantes ─────────────────────────────────────────────────────── */
  function variants(root) {
    var data = root.querySelector('[data-iyos-variants]');
    if (!data) return;

    var list;
    try {
      list = JSON.parse(data.textContent);
    } catch (e) {
      return;
    }

    var idInput = root.querySelector('[data-iyos-variant-id]');
    var priceEl = root.querySelector('[data-iyos-price]');
    var addBtn = root.querySelector('[data-iyos-add]');
    var addText = root.querySelector('[data-iyos-add-text]');
    var waBtn = root.querySelector('[data-iyos-wa]');
    var inputs = root.querySelectorAll('[data-iyos-option]');
    if (!inputs.length) return;

    var money = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GTQ';

    function chosen() {
      var out = [];
      inputs.forEach(function (i) {
        if (i.checked) out[Number(i.dataset.iyosOption) - 1] = i.value;
      });
      return out;
    }

    function update() {
      var want = chosen();
      var match = list.find(function (variant) {
        return want.every(function (val, k) { return !val || variant.options[k] === val; });
      });
      if (!match) return;

      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = format(match.price, money);
      if (addBtn) addBtn.disabled = !match.available;
      if (addText) addText.textContent = match.available ? addText.dataset.label || addText.textContent : 'Agotado';

      // El pedido se hace por WhatsApp: el mensaje debe nombrar la variante
      // que el cliente tiene elegida en pantalla, no la que trajo el servidor.
      if (waBtn) waBtn.href = enlaceWa(waBtn, match);

      // Mantiene la URL compartible apuntando a la variante elegida.
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }

    function enlaceWa(btn, variant) {
      var d = btn.dataset;
      var nombre = d.waTitulo;
      if (variant.title && variant.title !== 'Default Title') nombre += ' / ' + variant.title;

      var msg = String(d.waTpl)
        .replace('[producto]', nombre)
        .replace('[enlace]', d.waUrl + '?variant=' + variant.id);

      return 'https://wa.me/' + d.waNum + '?text=' + encodeURIComponent(msg);
    }

    function format(cents, code) {
      try {
        return new Intl.NumberFormat('es-GT', { style: 'currency', currency: code }).format(cents / 100);
      } catch (e) {
        return 'Q' + (cents / 100).toFixed(2);
      }
    }

    if (addText) addText.dataset.label = addText.textContent.trim();
    inputs.forEach(function (i) { i.addEventListener('change', update); });
  }

  function boot() {
    document.querySelectorAll('[data-iyos-pdp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
